











































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {ResponsavelSaraiva} from '@/model/resource/ResponsavelSaraiva'
import {ResponsavelSaraivaCollection} from '@/model/collection/ResponsavelSaraivaCollection'
import {ListResponsavelSaraivaSchema} from '@/schema/resource/ResponsavelSaraiva/ListResponsavelSaraivaSchema'
import {CsvResponsavelSaraivaSchema} from '@/schema/resource/ResponsavelSaraiva/CsvResponsavelSaraivaSchema'

@Component
export default class ListResponsavelSaraivaView extends Mixins(
  MixinQueryRouter
) {
  schema = new ListResponsavelSaraivaSchema()
  collection = new ResponsavelSaraivaCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: ResponsavelSaraiva) {
    Helper.pushByName('editResponsavelSaraiva', item.$id)
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new ResponsavelSaraivaCollection()
      .clearFilters()
      .addFilter(params)

    await csv.listCsvResponsavelSaraiva()
    new CsvResponsavelSaraivaSchema().downloadCsv(csv.all())
  }
}
